"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var FontColor;
(function (FontColor) {
    FontColor["White"] = "#f8f8f8";
    FontColor["Gray"] = "#727272";
    FontColor["LightGray"] = "#b8b8b8";
    FontColor["Blue"] = "#3498db";
    FontColor["Red"] = "#c0392b";
})(FontColor = exports.FontColor || (exports.FontColor = {}));
var BackgroundColor;
(function (BackgroundColor) {
    BackgroundColor["Black"] = "#000";
    BackgroundColor["White"] = "#f8f8f8";
    BackgroundColor["Yellow"] = "#fcdd8d";
    BackgroundColor["Pink"] = "#eea2c8";
    BackgroundColor["Red"] = "#e18e9f";
    BackgroundColor["Blue"] = "#92b3dd";
    BackgroundColor["Green"] = "#80d3d2";
    BackgroundColor["Purple"] = "#c0a7de";
    BackgroundColor["Gray"] = "#727272";
})(BackgroundColor = exports.BackgroundColor || (exports.BackgroundColor = {}));
var ButtonColor;
(function (ButtonColor) {
    ButtonColor["Active"] = "rgba(0,0,0,.1)";
})(ButtonColor = exports.ButtonColor || (exports.ButtonColor = {}));
var DrawerItemColor;
(function (DrawerItemColor) {
    DrawerItemColor["Hover"] = "rgba(0,0,0,.05)";
    DrawerItemColor["Active"] = "rgba(0,0,0,.1)";
})(DrawerItemColor = exports.DrawerItemColor || (exports.DrawerItemColor = {}));



//////////////////
// WEBPACK FOOTER
// ./src/components/styles/colors.ts
// module id = 277
// module chunks = 0